<!--电子账户充值-->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container account-recharge" v-loading="saveLoading">
      <el-form :rules="rules" ref="addRef" :model="addObj" label-width="150px" size="mini">
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <!-- 单据类型 -->
        <el-form-item :label="$t('fiAcInput.orderType')+ ':'">{{ $t('efubo.card.record.type2') }}</el-form-item>
        <!-- 账户类型 -->
        <el-form-item :label="$t('title.accout.type')+ ':'">{{ $t('fi.type.ac.e') }}</el-form-item>
        <!--  支付金额  -->
        <el-form-item :label="$t('busi.pay.amount')+ ':'" prop="localMoney">
          <el-input v-model="addObj.localMoney" clearable style="width: 30%"/>
        </el-form-item>
        <!-- 支付币种 -->
        <el-form-item :label="$t('Common.paymentCurrency')+ ':'" prop="localCurrency">
          <el-select v-model="addObj.localCurrency" style="width: 30%">
            <el-option v-for="item in localCurrencyList" :key="item.currencyCode" :label="item.currencyCode"
                       :value="item.currencyCode">
              <span>{{ item.currencyCode }} - </span>
              <span v-if="language === 'zh_CN'">{{ item.currencyName }}</span>
              <span v-else-if="language !== 'zh_CN' && item.currencyCode === 'BUK'">Myanmar kyat</span>
              <span v-else-if="language !== 'zh_CN' && item.currencyCode === 'IDR'">Indonesian Rupiah</span>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 充值金额  -->
        <el-form-item :label="$t('fi.czje')+ ':'">
          <el-input v-model="addObj.money" style="width: 30%" :readonly="true"/>
        </el-form-item>
        <!-- 充值方式 -->
        <el-form-item :label="$t('fiBankbookTempRecharge.moneyType')+ ':'" prop="tranType">
          <el-select v-model="addObj.tranType" style="width: 30%" @change="tranTypeChange">
            <el-option v-for="i in tranTypeList" :key="i.code" :label="$t(i.title)" :value="i.code"/>
          </el-select>
        </el-form-item>
        <!-- 摘要 -->
        <el-form-item :label="$t('sys.notes')+ ':'">
          <el-input type="textarea" :rows="3" v-model="addObj.remark" style="width: 30%"/>
        </el-form-item>
        <div v-if="this.addObj.tranType === '0'">
          <h3 style="color: #b3640d">{{ $t('mimember.uploadfile.files') }}</h3>
          <el-form-item>
            <el-upload
                class="upload-demo"
                ref="upload1"
                action="####"
                :before-upload="beforeUpload"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                list-type="picture-card"
                :file-list="fileList"
                :auto-upload="false">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">{{$t('Upload.prompt.1')}}</div>
            </el-upload>
          </el-form-item>
        </div>
        <div style="text-align: center; margin-bottom: 10px">
          <el-button type="primary" :loading="saveLoading" @click="addSaveBtn">{{ $t('button.save') }}</el-button>
          <el-button icon="el-icon-close" @click="closeBtn">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </el-form>
    </div>
    <el-dialog :visible.sync="picdialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import {accountChargeImgs, saveOrUpdateFiAcInput} from '@/api/ay-account-manager'
import { alCurrencyByUser, bankList} from '@/api/home'
import { mapGetters } from "vuex"

export default {
  name: "AccountRecharge",
  data() {
    return {
      RATE: '',
      fileList: [],
      localCurrencyList: [],
      accList: [],
      picdialogVisible: false,
      dialogImageUrl: null,
      bankIf: true,
      addObj: {
        localMoney: '',
        localCurrency: '',
        money: '',
        tranType: '0',
        accId: '',
        remark: '',
        rate: ''
      },
      saveLoading: false,
      rules: {
        localMoney: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        localCurrency: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        tranType: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        accId: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        bankValue: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}]
      },
      initDict: {
        tranType: 'trans_type_cn'
      }
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'userCode'
    ]),
    tranTypeList() {
      return this.$ll(this.initDict.tranType).filter(item => item.code === '0' || item.code === '2' || item.code === '3' || item.code === '16' || item.code === '17' || item.code === '18')
    }
  },
  watch: {
    "addObj.localMoney"(val) {
      this.addObj.money = (Number(val) * Number(this.RATE)).toFixed(2)
    }
  },
  created() {
    this.getAcc()
    this.getAlCurrency()
  },
  methods: {
    beforeUpload(file) {
      console.log(file)
      const acceptTypes = ['image/png', 'image/jpeg']
      const isJPG = acceptTypes.some(item => item === file.type)
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error(this.$t('Upload.prompt.2'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('Upload.prompt.3'))
        return false
      }
      return isJPG && isLt2M
    },
    handleRemove(file, fileList) {
      console.log(file, fileList, '删除')
    },
    handlePreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url
      this.picdialogVisible = true
    },

    addSaveBtn: function () {
      if(this.addObj.tranType === '0'){
        this.saveLoading = true
        let filesList = []
        this.$refs.upload1.uploadFiles.map(item => {
          filesList.push(item.raw)
        })
        // if (!filesList.length) {
        //   this.saveLoading = false
        //   return this.$message.error(this.$t('Upload.prompt.4'))
        // }
        this.$refs['addRef'].validate((valid) => {
          if (valid) {
            this.addObj.rate = this.RATE
            if (filesList.length) {
              const formData = new FormData()
              formData.append('agentNo', this.userCode)
              let i = 1
              for (let filesListElement of filesList) {
                formData.append('file' + i, filesListElement)
                i++
              }
              accountChargeImgs(formData).then(res => {
                this.addObj.attachmentids = res.data
                saveOrUpdateFiAcInput({...this.addObj}).then(() => {
                  this.$router.back(-1)
                  this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
                  this.saveLoading = false
                  this.resetForm('addRef')
                }).catch(err => {
                  console.error(err)
                  this.saveLoading = false
                  this.$message.error(this.$t('bdSendRegister.operaterFail'))
                })
              }).catch(err => {
                console.error(err, '上传图片错误')
              })
            } else {
              saveOrUpdateFiAcInput({...this.addObj}).then(() => {
                this.$router.back(-1)
                this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
                this.saveLoading = false
                this.resetForm('addRef')
              }).catch(err => {
                console.error(err)
                this.saveLoading = false
                this.$message.error(this.$t('bdSendRegister.operaterFail'))
              })
            }
          } else {
            this.saveLoading = false
          }
        })
      }else{
        this.saveLoading = true
        this.$refs['addRef'].validate((valid) => {
          if (valid) {
            this.addObj.rate = this.RATE
            saveOrUpdateFiAcInput(this.addObj).then(() => {
              this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
              this.$router.back()
              this.saveLoading = false
              // this.resetForm('addRef')
            }).catch(err => {
              console.error(err)
              this.saveLoading = false
              this.$message.error(this.$t('bdSendRegister.operaterFail'))
            })
          }
        })

      }

    },
    // addSaveBtn: function () {
    //
    // },
    closeBtn() {
      this.$router.back()
      this.resetForm('addRef')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 充值方式change
    tranTypeChange(val) {
      switch (val) {
        case '0' :
          this.imageIf = true
          this.bankIf = true
          break;
        case '1' :
          this.imageIf = false
          this.bankIf = false
          break;
        case '2' :
          this.imageIf = true
          this.bankIf = false
          break;
        case '3' :
          break;
        case '16' :
          this.imageIf = true
          this.bankIf = false
          break;
        case '17' :
          this.imageIf = true
          this.bankIf = false
          break;
        case '18' :
          break;
      }
    },
    // 获取公司收款账户
    getAcc() {
      bankList().then(res => {
        this.accList = res.data
      }).catch(err => {
        console.error(err)
      })
    },
    // 获取支付币种
    getAlCurrency() {
      this.saveLoading = true
      alCurrencyByUser().then(res => {
        this.localCurrencyList = res.data
        this.addObj.localCurrency = res.data[0].currencyCode
        this.RATE = res.data[0].rateToUsdLocal
        this.saveLoading = false
      }).catch(err => {
        console.error(err)
        this.saveLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
